
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "ContingencyResult": [
      "Contingency",
      "ContingencyError"
    ],
    "GetPropertyDetailsResult": [
      "GetPropertyDetailsFailed",
      "GetPropertyDetailsSuccess"
    ],
    "KeyTermMetadata": [
      "KeyTermCalculatedMetadata",
      "KeyTermUserOverrideMetadata"
    ],
    "KeyTermResult": [
      "KeyTerm",
      "KeyTermError"
    ],
    "MarketDataSource": [
      "CompsSource",
      "IndigoOffersSource",
      "MLSSource"
    ],
    "NotificationLogInterface": [
      "TransactionNotificationLogObject"
    ],
    "OfferScoreResult": [
      "OfferScore",
      "OfferScoreNotCalculated"
    ],
    "Table": [
      "TableData"
    ],
    "TableRowData": [
      "OffersByFinancingTypeTableRow"
    ]
  }
};
      export default result;
    